<template>
  <div
    class="left-chart-2"
    style="background-color: rgba(243, 243, 243, 0.4) !important"
  >
    <!-- <dv-decoration-2 style="height: 10px" /> -->
    <!-- <h3 class="mb-3 font-bold">数据指标</h3> -->
    <!-- <dv-decoration-11 style="width: 200px; height: 60px"
      ></dv-decoration-11
    > -->
    <div style="width: 100%" class="pl-2 pr-2">
      <ComponentSubtitle
        ><span class="sub-title">数据指标</span>
      </ComponentSubtitle>
    </div>
    <div class="w-full h-full">
      <div class="w-full">
        <div :color="[$color.borderColor, $color.borderColor]" class="">
          <div class="flex justify-between items-center pl-2 pr-2">
            <div>本月上门服务/累计上门服务</div>
            <div class="text-3xl cursor-pointer" @click="visiblePatrol = true">
              <span style="color: #e3b866">
                {{ globalData["currentMonthVisit"] || 0 }}
                <!-- {{
                  visitUsers["currentMonthVisitUsers"] &&
                  visitUsers["currentMonthVisitUsers"].length
                }} -->
                 </span
              >/<span :style="`color: ${$color.borderColor}`">
                {{ globalData["totalVisit"] || 0
              }}
                <!-- {{
                  visitUsers["totalVisitUsers"] &&
                  visitUsers["totalVisitUsers"].length
                }} -->
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex mt-2 buildingCount justify-between">
        <div
          style="height: 50px; padding-top: 0px"
          :color="[$color.borderColor, $color.borderColor]"
          class="flex-1 pl-2 pr-2 border-right-test"
        >
          <div
            class="flex items-center justify-between cursor-pointer"
            style="height: 100%"
          >
            <div>覆盖小区</div>
            <div class="text-2xl">
              {{
                (globalData["villages"] && globalData["villages"].length) || 1
              }}
            </div>
          </div>
        </div>
        <div
          style="height: 50px; padding-top: 0px"
          :color="[$color.borderColor, $color.borderColor]"
          class="flex-1 pl-2 pr-2"
        >
          <div
            class="flex items-center justify-between cursor-pointer"
            style="height: 100%"
          >
            <div>覆盖楼栋</div>
            <div class="text-2xl">
              {{ globalData["villages"] && globalData["buildingCount"] }}
            </div>
          </div>
        </div>
      </div>

      <div class="flex buildingCount2 justify-between">
        <div
          style="height: 50px; padding-top: 0px"
          :color="[$color.borderColor, $color.borderColor]"
          class="flex-1 pl-2 pr-2 border-right-test"
        >
          <div
            class="flex items-center justify-between cursor-pointer"
            style="height: 100%"
            @click="handlerVisibleBuilds"
          >
            <div>总建档人数</div>
            <div class="text-2xl">
              {{ globalData["total"] || 1 }}
            </div>
          </div>
        </div>
        <div
          style="height: 50px; padding-top: 0px"
          :color="[$color.borderColor, $color.borderColor]"
          class="flex-1 pl-2 pr-2"
        >
          <div
            class="flex items-center justify-between cursor-pointer"
            style="height: 100%"
            @click="archivesAnalyze"
          >
            <div>风险分析人数</div>
            <div class="text-2xl">
              {{ globalData["totalRiskAnalysisCount"] }}
            </div>
          </div>
        </div>
      </div>
      <!-- <div style="width: 100%; " class="bg-white p-2">
        <div id="consumption-pie" style="width: 340px; height: 100%"></div>
      </div> -->

      <div class="">
        <el-table
          :data="list"
          ref="scroll_Table"
          :max-height="isScreen16to9() ? 220 : 340"
          style="width: 100%"
          :border="true"
          :header-cell-style="{
            color: '#333',
            backgroundColor: 'transparent',
            borderColor: '#e2c6c0',
            padding: '4px 0',
            fontSize: '16px',
          }"
          :cell-style="{
            backgroundColor: 'transparent',
            borderColor: '#e2c6c0',
            padding: '4px 0',
          }"
          :row-style="{
            backgroundColor: 'transparent',
            borderColor: '#e2c6c0',
          }"
          @mouseenter.native="autoScroll(true)"
          @mouseleave.native="autoScroll(false)"
          ><el-table-column
            prop="category"
            label="镇街"
            width="width"
            align="left"
          >
            <template slot-scope="{ row }">
              <el-tooltip
                class="item"
                effect="dark"
                :content="row.category"
                placement="top-start"
              >
                <div class="ellipsis">{{ row.category }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="count"
            label="老年人健康管理率"
            width="width"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="cover"
            label="老年人家医签约率"
            width="width"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <ComponentDialogSelect :show.sync="visible"></ComponentDialogSelect>
      <ComponentDialogSelectBuilding
        :show.sync="visibleBuilding"
      ></ComponentDialogSelectBuilding>
      <ComponentSelectCommunity
        :show.sync="visibleCommunity"
      ></ComponentSelectCommunity>

      <ComponentDialogPlotSelect
        :show.sync="visiblePlot"
      ></ComponentDialogPlotSelect>
      <ComponentDialogPatrol :show.sync="visiblePatrol"></ComponentDialogPatrol>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import ComponentDialogSelect from "./DialogSelect.vue";
import ComponentDialogSelectBuilding from "./DialogSelectBuilding.vue";
import ComponentSelectCommunity from "./ComponentSelectCommunity.vue";
import ComponentDialogPlotSelect from "./DialogPlotSelect.vue";
import ComponentDialogPatrol from "./PatrolDialog.vue";
import { mapGetters } from "vuex";
import { isScreen16to9 } from "../../utils/index";
export default {
  name: "RightChart2",
  components: {
    ComponentDialogSelect,
    ComponentDialogSelectBuilding,
    ComponentSelectCommunity,
    ComponentDialogPlotSelect,
    ComponentDialogPatrol,
  },
  computed: {
    ...mapGetters([
      "globalData",
      "mapKey",
      "key",
      "communityKey",
      "visitUsers",
    ]),
  },
  watch: {
    globalData: {
      handler(n, o) {
        this.$nextTick(() => {
          this.initChart();
          this.autoScroll();
        });
      },
    },
  },
  data() {
    return {
      visible: false,
      visibleBuilding: false,
      visibleCommunity: false,
      visiblePlot: false,
      config: {
        data: [66, 45],
        shape: "roundRect",
      },
      visiblePatrol: false,
      list: [
        {
          category: "茄子溪",
          count: "38.83%",
          cover: "83.21%",
        },
        {
          category: "建胜镇",
          count: "67.92%",
          cover: "97.85%",
        },
        {
          category: "八桥镇",
          count: "44.51%",
          cover: "75.23%",
        },
        {
          category: "新山村",
          count: "64.95%",
          cover: "98.62%",
        },
        {
          category: "跳磴镇",
          count: "63.33%",
          cover: "89.42%",
        },
        {
          category: "春晖路",
          count: "72.56%",
          cover: "95%",
        },
        {
          category: "跃进村",
          count: "59.39%",
          cover: "96%",
        },
        {
          category: "九宫庙",
          count: "61.65%",
          cover: "86.79%",
        },
        {
          category: "合计",
          count: "58.89%",
          cover: "88.55%",
        },
      ],

      // 输出结果
      scrolltimer: "", // 自动滚动的定时任务
    };
  },
  methods: {
    isScreen16to9,
    initChart() {
      return;
    },
    async handlerVisibleBuilds() {
      let accessToken = await this.$store.dispatch("app/getToken");
      let link = `${process.env.VUE_APP_ARCHIVES_DOMAIN}?accessToken=${accessToken}&&street=${this.mapKey}&&community=${this.communityKey}`;
      window.open(link);
    },
    async archivesAnalyze() {
      let accessToken = await this.$store.dispatch("app/getToken");
      let link = `${process.env.VUE_APP_ARCHIVES_DOMAIN}?accessToken=${accessToken}&&hasArchivesReport=1&&street=${this.mapKey}&&community=${this.communityKey}`;
      window.open(link);
    },
    handlerVisible() {
      if (this.key == "house" || this.key == "street") {
        this.visiblePlot = true;
      }
      return;
      console.log(this.mapKey);
      if (this.mapKey == "main") {
        this.visibleCommunity = true;
      } else {
        this.visible = true;
      }
    },

    // 设置自动滚动
    autoScroll(stop) {
      if (this.scrolltimer) {
        window.clearInterval(this.scrolltimer);
      }
      const table = this.$refs.scroll_Table;
      // 拿到表格中承载数据的div元素
      const divData = table.$refs.bodyWrapper;
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      if (stop) {
        //再通过事件监听，监听到 组件销毁 后，再执行关闭计时器。
        window.clearInterval(this.scrolltimer);
      } else {
        this.scrolltimer = window.setInterval(() => {
          // 元素自增距离顶部1像素
          divData.scrollTop += 1;
          // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
          // console.log("可视高度", divData.clientHeight);
          // console.log("距离顶部", divData.scrollTop);
          // console.log("整个高度", divData.scrollHeight);
          // console.log("************");

          if (
            parseInt(divData.clientHeight) + parseInt(divData.scrollTop) ==
            parseInt(divData.scrollHeight)
          ) {
            // 重置table距离顶部距离
            divData.scrollTop = 0;
            // 重置table距离顶部距离。值=(滚动到底部时，距离顶部的大小) - 整个高度/2
            // divData.scrollTop = divData.scrollTop - divData.scrollHeight / 2
          }
        }, 150); // 滚动速度
      }
    },
  },
  mounted() {
    // this.initChart();
  },

  beforeDestroy() {
    this.autoScroll(true);
  },
};
</script>

<style lang="less" scoped>
.border-right-test {
  border-right: 1px solid @border-color !important;
}
.ellipsis {
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep {
  .el-table {
    font-size: 17px;
  }
  .el-table,
  .el-table__expanded-cell {
    background-color: transparent !important;
    border-bottom: 1px solid @border-color;
  }
  .el-table .thead {
    background-color: transparent !important;
  }
  .el-table tr {
    background: transparent !important;
  }
}
::v-deep {
  .buildingCount {
    border-top: 1px solid @border-color;
    border-bottom: 1px solid @border-color;
    .border-box-content {
      padding-top: 0px !important;
      // align-items: center;
      // justify-content: center;
      // align-content: space-between;
      // flex-direction: row;
    }
  }
  .buildingCount2 {
    border-bottom: 1px solid @border-color;
  }
}
.left-chart-2 {
  // width: 100%;
  // width: 200px;
  // background: #fff;
  color: @title-color !important;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  .rc1-header {
    font-size: 24px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
  }

  .rc1-chart-container {
    width: 320px;
    height: 320px;
  }
  .left {
    width: 30%;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .number {
      font-size: 34px;
      color: #096dd9;
      font-weight: bold;
      margin-bottom: 30px;
    }
  }

  .right {
    box-sizing: border-box;
  }
}
</style>
